module.exports = __webpack_public_path__ + "img/nav_qrcode_wechat.821f57c8.png";